export default {
  header: {
    title: 'Kup kartę podarunkową',
  },
  items: {
    gift_card: {
      label: 'Karta podarunkowa',
      title: 'Wybierz żądaną kwotę',
      description: 'Dodaj kartę podarunkową z wybraną ilością do koszyka',
    },
    expiration: {
      label: 'Ważna przez 3 lata',
      title: 'Ciesz się dawaniem prezentów!',
      description: 'Obdarowany może elastycznie wykorzystać voucher w ciągu 3 lat.',
    },
    delivery: {
      label: 'Dostawa natychmiastowa jako PDF na e-mail',
      title: 'Natychmiastowa dostawa jako PDF na e-mail',
      description: 'Po bezpiecznej płatności kartą kredytową, PayPal lub giropay otrzymasz voucher natychmiast.',
    },
  },
  form: {
    value: {
      title: 'Wybierz kwotę karty podarunkowej',
      custom: {
        label: 'Własna',
        placeholder: 'Wprowadź kwotę',
      },
    },
    quantity: {
      title: 'Ilość',
    },
    email: {
      title: 'Podaj adres e-mail, na który wyślemy kartę podarunkową',
      placeholder: 'Twój adres e-mail',
    },
  },
  confirmation: {
    title: {
      title: 'Utworzyć kartę podarunkową?',
      subtitle_one: 'Czy chcesz utworzyć 1 kartę podarunkową o wartości {{value}}?',
      subtitle_few: 'Czy chcesz utworzyć {{count}} karty podarunkowe na {{value}}?',
      subtitle_many: 'Czy chcesz utworzyć {{count}} kart podarunkowych na {{value}}?',
      subtitle_other: 'Czy chcesz utworzyć {{count}} karty podarunkowe o wartości {{value}}?',
    },
    description: {
      total: 'Łącznie:',
      email: 'E-Mail:',
      quantity: 'Ilość',
      amount: 'Kwota',
    },
    footer: {
      cancel: 'Anuluj',
      confirm: 'Potwierdź',
    },
  },
  buttons: {
    create: 'Utwórz',
  },
  toasts: {
    error: 'Tworzenie karty podarunkowej nie powiodło się.',
    success: 'Karta podarunkowa została pomyślnie utworzona.',
  },
};
